import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMirror = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M17.857,1.099l-2.78,1.523l1.316,2.87" }),
			/* @__PURE__ */ _jsx("path", { d: "M22.25,7.688l1.42498e-07,3.91892e-07c-0.324297,-0.89187 -0.838098,-1.70283 -1.506,-2.377l2.63225e-07,2.57887e-07c-1.40658,-1.37806 -3.3454,-2.07219 -5.307,-1.9" }),
			/* @__PURE__ */ _jsx("path", { d: "M6.292,22.982l2.779,-1.523l-1.315,-2.87" }),
			/* @__PURE__ */ _jsx("path", { d: "M1.9,16.393l1.87031e-07,5.17026e-07c0.322449,0.891373 0.834186,1.70231 1.5,2.377l1.66221e-07,1.63317e-07c1.40713,1.38254 3.34729,2.08258 5.313,1.917" }),
			/* @__PURE__ */ _jsx("path", { d: "M2.75,12.732c-0.55228,0 -1,-0.44772 -1,-1v-9.714c0,-0.55228 0.44772,-1 1,-1h6.786c0.55228,0 1,0.44772 1,1v9.714c0,0.55228 -0.44772,1 -1,1Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M14.464,22.982c-0.55228,0 -1,-0.44772 -1,-1v-9.759c0,-0.55228 0.44772,-1 1,-1h6.786c0.55228,0 1,0.44772 1,1v9.759c0,0.55228 -0.44772,1 -1,1Z" })
		]
	})
});
export default SvgMirror;
